<template>
  <div class="section-title">
    <h4>{{ heading }}</h4>
  </div>
</template>

<script>
export default {
  name: "SectionTitle",
  props: {
    heading: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped>
.section-title {
  width: fit-content;
  height: auto;
}

.section-title h4 {
  font-size: 23px;
  font-family: sans-serif;
  font-weight: 600;
  color: #003633;
  white-space: nowrap;
  text-align: center;
}

@media screen and (max-width: 570px) {
  .section-title h4 {
    font-size: 17px;
  }
}
</style>